module.exports = __webpack_public_path__ + "static/media/recommendation-widget-guide.f305f439.png";